import AiChat from './AiChat.vue';
import ConceptProvider from './ConceptProvider.vue';

export default {
    AiChat,
    ConceptProvider
};
